// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1h1E6","itemTitle":"ClientEmergencyInfo_itemTitle__1Wja7","itemText":"ClientEmergencyInfo_itemText__WN_I7"};